import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferralCode, readReferralCode } from '../services/referralAttributionService';

/**
 * The referrer code for this visit, from `?ref=` on any marketing page.
 *
 * WHY A HOOK AND NOT A PROP FROM EACH PAGE. The waitlist form appears in the
 * footer of every marketing page as well as on /waitlist, and a colleague's
 * link lands wherever they chose to point it. Reading the param where the form
 * is rendered means every placement attributes correctly without each page
 * having to remember to pass it down — the failure mode of prop-drilling here
 * is a silently uncredited referral, which nobody would notice.
 *
 * Capture is a side effect (it stores the code for the rest of the session),
 * so it runs in an effect rather than during render.
 */
export function useReferralCode(): string | null {
  const location = useLocation();
  const [code, setCode] = useState<string | null>(() => readReferralCode());

  useEffect(() => {
    setCode(captureReferralCode(location.search));
  }, [location.search]);

  return code;
}

export default useReferralCode;
